import {useContext, useMemo} from 'react';

import Color from 'color';
import randomcolor from 'randomcolor';
import {length} from 'stringz';

import type {Props} from './types';

import {ThemeContext} from '../../styles';

export const useController = ({text}: Props) => {
  const {theme} = useContext(ThemeContext);

  const letters = useMemo(
    () =>
      text
        ? text
            .replace(/[@#!$%^&*()+|~=`{}[\]:";'<>?,./\d]/g, '')
            // eslint-disable-next-line regexp/strict
            .split(/[\s-_]/)
            .filter(Boolean)
            .slice(0, 2)
            .filter(Boolean)
            .map((part: string) =>
              (length(part) > 1 ? part[0]! : part).toUpperCase(),
            )
        : '...',
    [text],
  );

  const colors = useMemo(() => {
    const firstColor = text
      ? randomcolor({
          seed: text,
        })
      : theme.color.v3.text.primary;

    const secondColor = Color(firstColor)
      .rotate(-20)
      .darken(0.2)
      .rgb()
      .string();

    return [firstColor, secondColor];
  }, [text, theme]);

  return {
    colors,
    letters,
  };
};
